import React from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

export default function ManageJobsInvitedSearchBar({ value, onChange, placeholder }) {
  return (
    <Input
      allowClear
      size="large"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      prefix={<SearchOutlined className="manage-jobs-invited-page__search-icon" />}
      className="manage-jobs-invited-page__search-input"
      placeholder={placeholder}
    />
  );
}
